import { ButtonHTMLAttributes, FC } from 'react';

import styles from './SeeMoreButton.module.scss';

interface Props {
  label: string;
  onClick?: ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
}

const SeeMoreButton: FC<Props> = ({ label, onClick = () => null }) => (
  <button type="button" className={styles.button} onClick={onClick}>
    {label}
  </button>
);

export default SeeMoreButton;
export type { Props as SeeMoreButtonProps };
